import { TextboxDialogData } from '@/shared/textbox-dialog.component';
import { GridReadyEvent } from '@ag-grid-community/core';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Config } from 'app/model/entities/config';
import { AgFns, GridOptionsExt } from 'app/shared/ag-fns';
import { DialogBaseComponent } from 'app/shared/dialog-base.component';
import { DomainService } from 'app/shared/domain.service';
import { environment } from 'environments/environment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';

 

@Component({
    templateUrl: './app-config-dialog.component.html',
    standalone: false
})
export class AppConfigDialogComponent  extends DialogBaseComponent<any> {
  configGridOptions: GridOptionsExt;
  configs: Config[];
  rangeDates: Date[];
  minDate = new Date(2026, 0, 1); // January 1, 2026
  isSettingLockoutSchedule = false;

  constructor(
      public config: DynamicDialogConfig<any>,
      public dialogRef: DynamicDialogRef,
      public domainService: DomainService,
      private http: HttpClient,
    ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Application Configuration - Default values",
      width: '1000px',
      height: 'max(600px, 80vh)',
    })

    this.prepare();
  }
  
  async prepare() {
    if (this.uow.hasChanges()) {
      this.dialogService.showOkMessage('Unable to open', 'Please save or cancel before trying this.');
      this.dialogRef.close(null);
      return;
    };
    this.configGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onConfigGridReady,
      getRowId: (p) => (p.data.groupName ?? '') + '|' + (p.data.fieldName ?? ''),
      onCellValueChanged: this.cellValueChanged,
    });
    
    
    this.configs = await this.dbQueryService.getConfigs();
    this.configs = this.configs.filter(c => c.shouldDisplay);
    
    this.isPageReady = true;
  }

  onConfigGridReady(event: GridReadyEvent) {
    const colDefs = [
      // { headerName: 'Group', field: 'groupName', maxWidth: 120 },
      // { headerName: 'Name', field: 'fieldName', width: 120 },
      { headerName: 'Description', field: 'fieldDescription', width: 200 },
      { headerName: 'Value', field: 'value', width: 200, editable: !!this.authUser?.isUserAdmin, valueParser: (p) => this.parseAndFmt(p) },
    ];
    const sortModel = [{ colId: 'fieldDescription', sort: 'asc' as const }];
    AgFns.initGrid(event, colDefs, sortModel);
  }

  cellValueChanged(event) {
    // Nothing needed here yet.
    // if (event != null) {
    //   if (event.oldValue != null || event.newValue != null) {
        
    //   }
    // }
    // const config = event?.node?.data as Config;
  }

  parseAndFmt(event) {
    const config = event?.node?.data as Config;
    if (config == null) { return; }
    if (config.fieldType == 'number') {
      const result =  this.parseFloatDefault(event.newValue, 0).toString();
      return result;
    } else {
      return event.newValue;
    }
  }

  parseFloatDefault(value: any, def = 0.0) {
    const v = parseFloat(value);
    return isNaN(v) ? def : v;
  }

  private findLockoutConfig(): Config | undefined {
    return this.configs.find(c => c.groupName == 'Lockout' && c.fieldName == 'Schedule');
  }

  editLockoutSchedule() {
    const config = this.findLockoutConfig();
    if (config != null && config.value != null) {
      try {            
        const dates = JSON.parse(config.value) as string[];
        this.rangeDates = dates.map(d => new Date(d));
      } catch { }
    }
    this.isSettingLockoutSchedule = true;
  }

  completeEditLockoutSchedule(save: boolean) {
    this.isSettingLockoutSchedule = false;
    if (!save) { return; }
    if (this.rangeDates == null || this.rangeDates.length != 2) { return; }
    let config = this.findLockoutConfig();
    if (config == null) {
      config = this.uow.createEntity(Config, {
        groupName: 'Lockout',
        fieldName: 'Schedule',
        fieldDescription: 'Lockout Schedule',
        fieldType: 'string',
        shouldDisplay: true,
      });
      this.configs.push(config);
    }
    config.value = JSON.stringify(this.rangeDates.map(d => d.toISOString()));
  }

  clearLockoutSchedule() {
    const config = this.findLockoutConfig();
    if (config != null) {
      config.value = undefined;
    }
    this.rangeDates = [];
  }

  async generateToken() {
    const url = environment.apiRoot + 'api/Login/GetApiToken';
    const response = await firstValueFrom(this.http.post<{ token }>(url, {}));
    const config: TextboxDialogData = {
      pretext: 'Copy the value in the box below, and include it in an Authorization header in all calls to the Uniformax API.',
      text: response.token,
      posttext: 'Protect this token as a password!  It grants access to Job Orders in Uniformax.',
    };
    await this.domainService.dialogService.textboxDialog('Bearer Token', config);
  }

  async save() {
    await this.dbSaveService.saveChanges();
    this.dbQueryService.updateAppConfig(this.configs);
    this.dialogRef.close(null);
  }
  
  async undo() {
    this.configGridOptions.apiX.stopEditing();
    this.configs.slice().forEach(x => x.entityAspect.rejectChanges());
    this.configs = await this.dbQueryService.getConfigs();
    // needed because of valueParser above
    this.configGridOptions.apiX.refreshCells( { force: true});
  }

  async close() {
    this.configGridOptions.apiX.stopEditing();
    if (this.uow.hasChanges()) {
      const ok = await this.dialogService.yesNoDialog('Changes have not been saved', 'Do you want to save before exiting?');
      if (ok) {
        await this.dbSaveService.saveChanges();
      } else {
        this.dbSaveService.rejectChanges();
      }
    }

    this.dialogRef.close(null);
  }

  
}
